import React from 'react';
import cx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

import { Classroom } from 'types/schema-generated-types';
import BreakableTypography from '../BreakableTypography';
import ProductIconList from '../ProductIconList';

const useStyles = makeStyles(theme => ({
  root: {
    border: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1),
    cursor: 'pointer',
    lineHeight: 1.5,
    borderRadius: theme.spacing(0.75),
    '&:hover': {
      boxShadow: '0 1px 10px 2px rgba(0, 0, 0, 0.20)',
      transform: 'scale(1.01, 1.01)'
    }
  },
  productsContainer: {
    marginTop: theme.spacing()
  }
}));

export interface ClassroomCardProps {
  classroom: Classroom;
  onClick: () => void;
  className?: string;
}

const ClassroomCard: React.FC<ClassroomCardProps> = ({ classroom, onClick, className }) => {
  const classes = useStyles();
  const { t } = useTranslation('ClassroomCard');

  const studentCount = classroom.stats?.studentCount ?? 0;

  return (
    <Paper
      onClick={onClick}
      className={cx(classes.root, className)}
      style={{ borderLeft: `8px solid ${classroom.color ?? 'red'}` }}
      elevation={0}
    >
      <BreakableTypography variant="h5">{classroom.name}</BreakableTypography>
      <Typography variant="body1">
        {t('No. of Students: {{studentCount}}', { studentCount })}
      </Typography>
      <ProductIconList
        title={t('Products')}
        emptyMessage={t('No assigned products')}
        licenseUsage={classroom.licenseUsage}
      />
    </Paper>
  );
};

export default ClassroomCard;
